// extracted by mini-css-extract-plugin
var _1 = "MagicLinkView-module__animatedBackground--DzGrX";
var _2 = "MagicLinkView-module__errorMessage--f3OYm";
export { _1 as "animatedBackground", _2 as "errorMessage" }
